<template>
  <a :class="[this.disabled ? 'exit-button disabled' : 'exit-button animated fadeIn delay-1s']">Exit Game</a>
</template>

<script>
export default {
  name: 'exit-button',
  props: ['disabled']
}
</script>

<style lang="scss" scoped>
  .exit-button {
    background: #F98B02;
    border-radius: 30px;
    bottom: 35px;
    display: inline-block;
    position: absolute;
    right: 50px;
    padding: 10px 25px;
    color: #fff;
    font-weight: bold;
    font-size: 18px;

    &.disabled {
      opacity: 0.65;
      pointer-events: none;
    }
  }

</style>
